import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import QuickbooksContainer from '../../containers/accounting/Quickbooks';

class FMPQuickbooksVendorSelect extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		const { quickbooksVendors, searchQuickbooksVendors } = this.props;
		if (_.isEmpty(quickbooksVendors)) {
			searchQuickbooksVendors({
				params: {},
			});
		}
	}

	render() {
		const {
			label,
			value,
			path,
			onChange,
			error,
			helpText,
			md,
			readOnly,
			quickbooksVendors,
		} = this.props;

		if (!quickbooksVendors) {
			return (
				<Grid spacing={2} container>
					<Grid item xs={12} md={md}>
						<Select value={value} input={<Input id={path} readOnly={readOnly} />}>
							<MenuItem key={'loading quickbooks vendors'} value={'loading'} disabled>
								Loading vendors from quickbooks...
							</MenuItem>
						</Select>
					</Grid>
				</Grid>
			);
		}

		const quickbooksVendorOptions = quickbooksVendors.map((quickbooksVendor) => {
			const { quickbooksVendorId, DisplayName, ParentRef } = quickbooksVendor;

			let display = DisplayName;
			if (ParentRef) {
				display = <div style={{ paddingLeft: 20 }}>{DisplayName}</div>;
			}

			return {
				value: quickbooksVendorId,
				display,
			};
		});

		const hasError = !!error;
		const _onChange = (event) => {
			onChange(event.target.value, path);
		};

		return (
			<Grid spacing={2} container>
				<Grid item xs={12} md={md}>
					<FormControl fullWidth={true} error={hasError}>
						<InputLabel htmlFor={path}>{label}</InputLabel>
						<Select
							value={value}
							onChange={_onChange}
							input={<Input id={path} readOnly={readOnly} />}
						>
							{_.sortBy(quickbooksVendorOptions, 'display').map((quickbooksVendorOption) => {
								const { display, value } = quickbooksVendorOption;
								return (
									<MenuItem key={value} value={value}>
										{display}
									</MenuItem>
								);
							})}
						</Select>
						{hasError && <FormHelperText>{error}</FormHelperText>}
						{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
					</FormControl>
				</Grid>
			</Grid>
		);
	}
}

FMPQuickbooksVendorSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	searchQuickbooksVendors: PropTypes.func,
	quickbooksVendors: PropTypes.array,

	md: PropTypes.number,
	helpText: PropTypes.string,
	readOnly: PropTypes.bool,
};

export default _.flow([QuickbooksContainer])(FMPQuickbooksVendorSelect);
